/* homepage-custom.js — loaded by sections/homepage-custom.liquid */

function toggleFaq(btn) {
  var isOpen = btn.getAttribute('aria-expanded') === 'true';
  // Close all
  document.querySelectorAll('.faq-btn').forEach(function(b) {
    b.setAttribute('aria-expanded', 'false');
    var ans = b.parentNode.querySelector('.faq-ans');
    if (ans) ans.classList.remove('open');
  });
  // Open clicked if it was closed
  if (!isOpen) {
    btn.setAttribute('aria-expanded', 'true');
    var ans = btn.parentNode.querySelector('.faq-ans');
    if (ans) ans.classList.add('open');
  }
}

(function() {
  function restructureHomepage() {
    if (window.location.pathname !== '/' && window.location.pathname !== '') return;
    if (document.getElementById('bm-hp-restructured')) return;

    /* Mark as done */
    var marker = document.createElement('div');
    marker.id = 'bm-hp-restructured';
    marker.style.display = 'none';
    document.body.appendChild(marker);

    /* 1. Fix trust strip: replace 4 items with 3 correct items */
    var ts = document.querySelector('.trust-strip');
    if (ts) {
      ts.innerHTML = [
        '<div class="trust-item">',
          '<div class="trust-icon">',
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
          '</div>',
          '<div class="trust-item-label">Wysyłka w ciągu 24h<strong>Błyskawiczna realizacja zamówienia</strong></div>',
        '</div>',
        '<div class="trust-item">',
          '<div class="trust-icon">',
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.77a16 16 0 0 0 6.29 6.29l.95-.86a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>',
          '</div>',
          '<div class="trust-item-label">Obsługa na poziomie<strong>Odpowiadamy 7 dni w tygodniu</strong></div>',
        '</div>',
        '<div class="trust-item">',
          '<div class="trust-icon">',
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
          '</div>',
          '<div class="trust-item-label">Bezpieczna płatność<strong>Szyfrowane transakcje online</strong></div>',
        '</div>'
      ].join('');
      ts.style.gridTemplateColumns = 'repeat(3, 1fr)';
    }

    /* 2. Move trust strip AFTER collections section */
    var kolekcje = document.getElementById('kolekcje');
    if (kolekcje && ts && ts.parentNode) {
      kolekcje.parentNode.insertBefore(ts, kolekcje.nextSibling);
    }

    /* 3. Remove USP strip */
    var usp = document.querySelector('.usp-strip');
    if (usp) usp.remove();

    /* 4. Fix brand section labels */
    var brandEyebrow = document.querySelector('#o-nas .sec-eyebrow');
    if (brandEyebrow) brandEyebrow.textContent = 'O Nas';
    var brandTitle = document.querySelector('#o-nas .sec-title');
    if (brandTitle) brandTitle.innerHTML = 'Założona<br>z Pasją do Mody';

    var brandStats = document.querySelector('#o-nas .brand-stats');
    if (brandStats) {
      brandStats.innerHTML = '<div><span class="stat-val">5 TYS.+</span><span class="stat-lbl">Zadowolonych Klientek</span></div><div><span class="stat-val">99%</span><span class="stat-lbl">Pozytywnych Opinii</span></div>';
    }

    /* 5. Fix products eyebrow */
    var nowEyebrow = document.querySelector('#nowosci .sec-eyebrow');
    if (nowEyebrow) nowEyebrow.textContent = 'Prosto do Butiku';

    /* 7. Move newsletter BEFORE testimonials */
    var nlSection2 = document.querySelector('.nl-section');
    var opinie = document.getElementById('opinie');
    if (nlSection2 && opinie && opinie.parentNode) {
      if (nlSection2.compareDocumentPosition(opinie) & Node.DOCUMENT_POSITION_PRECEDING) {
        opinie.parentNode.insertBefore(nlSection2, opinie);
      }
    }
  }

  /* Enhance hero paths — make them more visible like reference */
  function enhanceHeroPaths() {
    var NS = 'http://www.w3.org/2000/svg';
    var svg1 = document.getElementById('paths-svg-1');
    var svg2 = document.getElementById('paths-svg-2');
    if (!svg1 && !svg2) return;

    function buildPath(i, pos) {
      /* Paths sweeping from bottom-right toward upper-left, matching reference */
      var x0 = 1440 + i * 12 * pos,  y0 = 900 + i * 8,
          cx1= 900  + i * 10 * pos,  cy1= 500 - i * 7,
          cx2= 400  - i * 6  * pos,  cy2= 150 - i * 5,
          x1 = -200 - i * 10 * pos,  y1 = -100 - i * 6;
      return 'M' + x0 + ' ' + y0 +
             ' C' + cx1 + ' ' + cy1 +
             ' ' + cx2 + ' ' + cy2 +
             ' ' + x1  + ' ' + y1;
    }

    function fillSvg(svg, pos) {
      if (!svg) return;
      svg.innerHTML = '';
      svg.setAttribute('viewBox', '0 0 1440 900');
      svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
      svg.style.overflow = 'visible';
      for (var i = 0; i < 40; i++) {
        var path = document.createElementNS(NS, 'path');
        path.setAttribute('d', buildPath(i, pos));
        path.setAttribute('stroke', '#c9a45c');
        path.setAttribute('stroke-width', String(0.4 + i * 0.038));
        path.setAttribute('fill', 'none');
        path.style.opacity = String(Math.min(0.08 + i * 0.030, 0.62));
        svg.appendChild(path);
      }
    }

    fillSvg(svg1, 1);
    fillSvg(svg2, -1);
  }

  /* Also fix collections grid from bento to 4-column row */
  function fixCollectionsGrid() {
    var bento = document.querySelector('.bento');
    if (!bento) return;
    bento.style.gridTemplateColumns = 'repeat(4, 1fr)';
    bento.style.gridTemplateRows = '480px';
    /* Remove special card modifiers */
    var featCard = bento.querySelector('.coll-card--feat');
    if (featCard) { featCard.classList.remove('coll-card--feat'); }
    var wideCard = bento.querySelector('.coll-card--wide');
    if (wideCard) { wideCard.classList.remove('coll-card--wide'); }
  }

  /* Collections slider — transform-based (no native scroll, no iOS bug) */
  function initCollCarousel() {
    var slider = document.querySelector('[data-coll-slider]');
    if (!slider || slider._bmInit) return;
    slider._bmInit = true;

    var track   = slider.querySelector('[data-coll-track]');
    var cards   = [].slice.call(slider.querySelectorAll('[data-coll-card]'));
    var prevBtn = slider.querySelector('[data-coll-prev]');
    var nextBtn = slider.querySelector('[data-coll-next]');
    var bar     = slider.querySelector('[data-coll-bar]');
    var curEl   = slider.querySelector('[data-coll-cur]');
    var totEl   = slider.querySelector('[data-coll-tot]');
    var N = cards.length;
    var current = 0;
    if (!track || !N) return;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    if (totEl) totEl.textContent = pad(N);

    function triggerShine(card) {
      var shine = card.querySelector('.coll-shine');
      if (!shine) return;
      shine.classList.remove('do-shine');
      void shine.offsetWidth;
      shine.classList.add('do-shine');
    }

    function go(index, silent) {
      index = Math.max(0, Math.min(N - 1, index));
      current = index;
      var cardW = cards[0] ? cards[0].offsetWidth : 0;
      var gap   = parseInt(window.getComputedStyle(track).gap) || 14;
      var tx    = -(index * (cardW + gap));
      var maxTx = -(track.scrollWidth - track.parentElement.offsetWidth);
      tx = Math.max(maxTx, tx);
      track.style.transform = 'translateX(' + tx + 'px)';
      cards.forEach(function(c, i) {
        var diff = Math.abs(i - current);
        var wasActive = c.classList.contains('is-active');
        c.classList.toggle('is-active', i === current);
        c.classList.toggle('is-near',   diff === 1);
        if (i === current && !wasActive && !silent) triggerShine(c);
      });
      if (prevBtn) prevBtn.disabled = current <= 0;
      if (nextBtn) nextBtn.disabled = current >= N - 1;
      if (bar)   bar.style.width = (N > 1 ? (current / (N - 1)) * 100 : 0) + '%';
      if (curEl) curEl.textContent = pad(current + 1);
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { stopAuto(); go(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { stopAuto(); go(current + 1); });

    /* Touch: live drag, snap to nearest card on release */
    var _sx = 0, _sy = 0, _dir = null, _baseTx = 0, _snapTimer = null;

    /* Read the VISUAL (mid-animation) translateX from computed style matrix */
    function getVisualTx() {
      var m = window.getComputedStyle(track).transform;
      if (!m || m === 'none') return 0;
      var v = m.match(/matrix\([^,]+,[^,]+,[^,]+,[^,]+,\s*(-?[\d.]+)/);
      return v ? parseFloat(v[1]) : 0;
    }

    track.addEventListener('touchstart', function(e) {
      clearTimeout(_snapTimer);
      _baseTx = getVisualTx();                              /* visual position, even mid-animation */
      track.style.transition = 'none';
      track.style.transform  = 'translateX(' + _baseTx + 'px)'; /* freeze immediately */
      _sx = e.touches[0].clientX;
      _sy = e.touches[0].clientY;
      _dir = null;
      stopAuto();
    }, { passive: true });

    track.addEventListener('touchmove', function(e) {
      var rawDx = e.touches[0].clientX - _sx;
      var rawDy = e.touches[0].clientY - _sy;
      var adx = Math.abs(rawDx), ady = Math.abs(rawDy);
      if (_dir === null && (adx > 5 || ady > 5)) _dir = adx >= ady ? 'x' : 'y';
      if (_dir === 'x') {
        e.preventDefault();
        var minTx = -(track.scrollWidth - track.parentElement.offsetWidth);
        track.style.transform = 'translateX(' + Math.max(minTx, Math.min(0, _baseTx + rawDx)) + 'px)';
      }
    }, { passive: false });

    track.addEventListener('touchend', function(e) {
      if (_dir !== 'x') { startAuto(); return; }

      var swipeDx = e.changedTouches[0].clientX - _sx;
      var cardW   = cards[0] ? cards[0].offsetWidth : 0;
      var gap     = parseInt(window.getComputedStyle(track).gap) || 14;
      var step    = (cardW + gap) || 1;
      /* Compute fractional index from current drag position */
      var nowTx   = parseFloat((track.style.transform.match(/(-?[\d.]+)/) || [0,0])[1]);
      var floatIdx = -nowTx / step;
      var target;
      if (Math.abs(swipeDx) > 30) {
        target = swipeDx < 0 ? Math.ceil(floatIdx) : Math.floor(floatIdx);
      } else {
        target = Math.round(floatIdx);
      }
      target = Math.max(0, Math.min(N - 1, target));

      track.style.transition = 'transform .38s cubic-bezier(.25,.46,.45,.94)';
      go(target);
      /* Restore CSS-defined transition after snap so button/autoplay still work */
      _snapTimer = setTimeout(function() { track.style.transition = ''; }, 420);
      startAuto();
    });

    /* Tap ripple — gold burst from pointer position */
    cards.forEach(function(card) {
      card.addEventListener('pointerdown', function(e) {
        var rect = card.getBoundingClientRect();
        var r = document.createElement('span');
        r.className = 'coll-ripple';
        r.style.left = (e.clientX - rect.left) + 'px';
        r.style.top  = (e.clientY - rect.top)  + 'px';
        card.appendChild(r);
        setTimeout(function() { if (r.parentNode) r.parentNode.removeChild(r); }, 620);
      });
    });

    /* Entrance reveal when section scrolls into view */
    if ('IntersectionObserver' in window) {
      var revealed = false;
      var io = new IntersectionObserver(function(entries) {
        if (revealed || !entries[0].isIntersecting) return;
        revealed = true; io.disconnect();
        cards.forEach(function(c, i) {
          setTimeout(function() { c.classList.add('is-revealed'); }, i * 90 + 40);
        });
      }, { threshold: 0.12 });
      io.observe(slider);
    } else {
      cards.forEach(function(c) { c.classList.add('is-revealed'); });
    }

    /* Autoplay */
    var autoId;
    function startAuto() {
      stopAuto();
      autoId = setInterval(function() { go(current < N - 1 ? current + 1 : 0); }, 5200);
    }
    function stopAuto() { clearInterval(autoId); }
    slider.addEventListener('mouseenter', stopAuto);
    slider.addEventListener('mouseleave', startAuto);

    go(0, true);
    startAuto();
  }

  /* ── TESTIMONIALS 3D CAROUSEL ──────── */
  function initTestiCarousel() {
    var stage = document.querySelector('[data-testi]');
    if (!stage || stage._bmTestiInit) return;
    stage._bmTestiInit = true;

    var slides = [].slice.call(stage.querySelectorAll('[data-testi-slide]'));
    var N = slides.length;
    if (!N) return;

    var current = 1; // card index 1 starts in center
    var isDragging = false, startX = 0;

    /*
     * State table: xm = x multiplier of OFFSET, ry = rotateY (deg)
     * Index mapping: diff + 2 (so diff=-2 → idx 0, diff=0 → idx 2, diff=+2 → idx 4)
     */
    var STATES = [
      { xm: -2, ry: 48, sc: 0.65, op: 0,    tz: -220, rz: -10 }, // far-left  (hidden)
      { xm: -1, ry: 28, sc: 0.82, op: 0.60, tz: -90,  rz: -5  }, // prev-left
      { xm:  0, ry:  0, sc: 1.00, op: 1.0,  tz:   0,  rz:  0  }, // active
      { xm:  1, ry:-28, sc: 0.82, op: 0.60, tz: -90,  rz:  5  }, // next-right
      { xm:  2, ry:-48, sc: 0.65, op: 0,    tz: -220, rz:  10 }, // far-right (hidden)
    ];

    function getSlideHalfW() {
      return window.innerWidth <= 680
        ? Math.min(150, window.innerWidth * 0.42)
        : 190; // 380px / 2
    }

    function getOffset() {
      var W = window.innerWidth;
      // .testi-clip handles clipping — no maxSafe needed
      if (W <= 480) return Math.round(W * 0.46);  // ~173px on 375px → side cards peek from edges
      if (W <= 680) return Math.round(W * 0.43);
      return Math.min(430, Math.max(280, Math.round(W * 0.33)));
    }

    function lerp(a, b, t) { return a + (b - a) * t; }

    function getDiff(idx) {
      return idx - current; // linear, not circular
    }

    function applyTransforms(prog) {
      var offset = getOffset();
      prog = Math.max(-1, Math.min(1, prog));
      slides.forEach(function(slide, i) {
        var diff  = getDiff(i);
        var clamp = Math.max(-2, Math.min(2, diff));
        var fromS = STATES[clamp + 2];
        var toKey = Math.max(-2, Math.min(2, prog < 0 ? clamp - 1 : clamp + 1));
        var toS   = STATES[toKey + 2];
        var t     = Math.abs(prog);
        var x  = lerp(fromS.xm, toS.xm, t) * offset;
        var ry = lerp(fromS.ry, toS.ry, t);
        var sc = lerp(fromS.sc, toS.sc, t);
        var op = lerp(fromS.op, toS.op, t);
        var tz = lerp(fromS.tz, toS.tz, t);
        var rz = lerp(fromS.rz, toS.rz, t);
        slide.style.transform = 'translateX(calc(-50% + ' + x.toFixed(1) + 'px)) translateZ(' + tz.toFixed(1) + 'px) rotateY(' + ry.toFixed(2) + 'deg) rotateZ(' + rz.toFixed(2) + 'deg) scale(' + sc.toFixed(3) + ')';
        slide.style.opacity   = Math.max(0, op).toFixed(3);
        slide.style.zIndex    = diff === 0 ? 3 : Math.abs(diff) === 1 ? 2 : 1;
        slide.dataset.active  = diff === 0 ? '1' : '0';
      });
    }

    var testiSection = stage.closest('section') || stage.parentElement;

    function updateDots() {
      (testiSection || stage).querySelectorAll('[data-testi-dot]').forEach(function(d) {
        d.classList.toggle('is-active', parseInt(d.getAttribute('data-testi-dot')) === current);
      });
    }

    function updateNav() {
      if (prevBtn) prevBtn.disabled = current <= 0;
      if (nextBtn) nextBtn.disabled = current >= N - 1;
    }

    function goTo(idx, instant) {
      current = Math.max(0, Math.min(N - 1, idx));
      if (instant) {
        slides.forEach(function(s) { s.style.transition = 'none'; });
        applyTransforms(0);
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            slides.forEach(function(s) { s.style.transition = ''; });
          });
        });
      } else {
        slides.forEach(function(s) { s.style.transition = ''; });
        applyTransforms(0);
      }
      updateDots();
      updateNav();
    }

    var track = stage.querySelector('[data-testi-track]');

    function onStart(e) {
      isDragging = true;
      startX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
      slides.forEach(function(s) { s.style.transition = 'none'; });
      track.classList.add('is-dragging');
    }
    function onMove(e) {
      if (!isDragging) return;
      var cx = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
      var dx = cx - startX;
      // Block dragging past endpoints
      if (current === 0 && dx > 0) dx = 0;
      if (current === N - 1 && dx < 0) dx = 0;
      if (e.type === 'touchmove' && Math.abs(dx) > 8) e.preventDefault();
      applyTransforms(dx / 270);
    }
    function onEnd(e) {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      var cx = (e.type === 'touchend' && e.changedTouches[0]) ? e.changedTouches[0].clientX : (e.clientX || startX);
      var dx = cx - startX;
      slides.forEach(function(s) { s.style.transition = ''; });
      if (Math.abs(dx) > 65) {
        goTo(dx < 0 ? current + 1 : current - 1);
      } else {
        applyTransforms(0); // snap back
      }
    }

    track.addEventListener('mousedown', onStart);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onEnd);
    track.addEventListener('touchstart', onStart, { passive: true });
    track.addEventListener('touchmove', onMove, { passive: false });
    track.addEventListener('touchend', onEnd);

    var prevBtn = (testiSection || stage).querySelector('[data-testi-prev]');
    var nextBtn = (testiSection || stage).querySelector('[data-testi-next]');
    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });
    (testiSection || stage).querySelectorAll('[data-testi-dot]').forEach(function(d) {
      d.addEventListener('click', function() { goTo(parseInt(d.getAttribute('data-testi-dot'))); });
    });

    goTo(1, true); // card 2 (index 1) in center on init
  }

  function init() {
    restructureHomepage();
    fixCollectionsGrid();
    enhanceHeroPaths();
    initCollCarousel();
    initTestiCarousel();
  }

  /* Fix search-button: replace 'c' glyph with proper SVG */
  var SEARCH_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:20px;height:20px;display:block;pointer-events:none"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';

  function fixSearchIcon() {
    document.querySelectorAll('#header-group .search-action--hidden-on-drawer').forEach(function(el) {
      el.style.setProperty('display', 'none', 'important');
    });
    var searchBtns = document.querySelectorAll('search-button button, .search-action button, search-button[is="search-button"]');
    if (!searchBtns.length) {
      searchBtns = document.querySelectorAll('search-button, .search-action');
    }
    searchBtns.forEach(function(btn) {
      if (btn.closest && btn.closest('.search-action--hidden-on-drawer')) return;
      if (btn._bmFixed) return;
      btn._bmFixed = true;
      var hasSvg = btn.querySelector('svg');
      if (!hasSvg) {
        /* Inject proper search SVG */
        btn.innerHTML = SEARCH_SVG;
      } else {
        hasSvg.style.cssText = 'width:20px!important;height:20px!important;display:block!important;pointer-events:none;';
      }
      btn.style.cssText = (btn.style.cssText||'') + ';display:inline-flex!important;align-items:center!important;justify-content:center!important;width:40px!important;height:40px!important;padding:0!important;cursor:pointer!important;border-radius:6px!important;background:none!important;border:none!important;';
    });
  }

  /* Keep logo visible during scroll - prevent JS from hiding it */
  function keepLogoVisible() {
    var logo = document.getElementById('bm-nav-logo-wrap');
    if (!logo || logo._bmLogoGuard) return;
    logo._bmLogoGuard = true;
    new MutationObserver(function() {
      var drawerOpen = !!(
        document.querySelector('menu-drawer[open]') ||
        document.querySelector('details[open].menu-drawer-container')
      );
      if (!drawerOpen && logo.style.opacity === '0') {
        logo.style.removeProperty('opacity');
      }
    }).observe(logo, { attributes: true, attributeFilter: ['style'] });
  }

  function initAll() {
    init();
    fixSearchIcon();
    keepLogoVisible();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('page:load', initAll);
  document.addEventListener('turbo:load', initAll);
  [300, 800, 2000].forEach(function(ms) { setTimeout(fixSearchIcon, ms); });
})();
